
export class RentalDetailsPackOptionSelectionItem {

    constructor(productId: number, packagePosition: number, productName: string, productPrice: number, isSelected: boolean) {
        this.productId = productId;
        this.packagePosition = packagePosition;
        this.productName = productName;
        this.productPrice = productPrice;
        this.isSelected = isSelected;

    }

    productId: number;
    packagePosition: number;
    productName: string;
    productPrice: number;
    isSelected: boolean;
}